module.exports = __webpack_public_path__ + "static/18-bb5a1e848a0588cfdc174cdd7b094967.jpg";